import { notifyError } from "shared/ui/toast";

export const catchError = (error: unknown) => {
  console.error(error);
  if (error instanceof Error) {
    return notifyError(error.name, error.message);
  }

  return notifyError("Something went wrong", `${error}`);
};
